import React from "react";

import "./Footer.scss";
import { Link } from "react-router-dom";
import bg from "../../assets/footer-bg.jpg";
import logo from "../../assets/tmovie.png";


const Footer = () => {
  return (
    <div className="footer" style={{backgroundImage: `url(${bg})` }}>
      <div className="footer__content container">
        <div className="footer__content__logo">
        <div className="logo">
          <img src={logo} alt="" />
          <Link to="/" className="Name">Vmovies</Link>
        </div>
        </div>
        <div className="footer__content__menus">
          <div className=" footer__content__menu">
            <Link to="/"> Home </Link>
            <Link to="/"> Contact Us </Link>
            <Link to="/"> Term of servicecs</Link>
            <Link to="/"> About Us </Link>
          </div>

          <div className=" footer__content__menu">
            <Link to="/"> Live </Link>
            <Link to="/"> FAQ </Link>
            <Link to="/"> Premium</Link>
            <Link to="/"> Pravacy </Link>
          </div>
          <div className=" footer__content__menu">
            <Link to="/"> you must watch </Link>
            <Link to="/"> Recent release </Link>
            <Link to="/"> Top IMDB</Link>
            <Link to="/"> New </Link>
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default Footer;
